// Global Dispatcher allows us to emmit and listen for global events across our app.
// For docs refer to: http://backbonejs.org/#Events
var Dispatcher = _.clone(Backbone.Events);

module.exports = Dispatcher;
